





























































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Surface, Typography, Picture } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';
import ModalOptions from '@/components/Modal/ModalOptions';

import DateUtils from '@/utils/DateUtils';
import eventBus from '@/utils/eventBus';
import {
  TemplatesDictionary,
  EMarketingCenterTemplates,
  IMarketingCenterTemplate
} from '@/models/marketingCenter/template';
import { IMarketingCenterGetAsset } from '@/models/marketingCenter/post';

@Component({ components: { Surface, Typography, Picture, FilledButton } })
export default class MarketingCenterPostCard extends Vue {
  @Prop(String) readonly name?: string;
  @Prop(String) readonly thumb?: string;
  @Prop(String) readonly createdAt?: string;
  @Prop(String) readonly id?: string;
  @Prop({ default: () => [] }) readonly assets?: IMarketingCenterGetAsset[];
  @Prop(String) readonly postTemplate?: EMarketingCenterTemplates;
  @Prop({ default: '' }) gaContextPage?: string;

  options: boolean = false;

  getDate(date: string) {
    return DateUtils.formattedDate({
      date: date,
      applyTimezone: true
    });
  }

  openModal(type: string, data?: any) {
    const keys: { [i: string]: string } = {
      delete: 'marketingCenterDeleteModal',
      share: 'marketingCenterShareModal',
      download: 'marketingCenterDownloadModal'
    };

    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        keys[type],
        false,
        true,
        true,
        true,
        true,
        true,
        true
      ),
      {
        ...data,
        gaContextPage: this.gaContextPage
      }
    );
  }

  openDownloadModal() {
    if (this.gaContextPage) {
      this.$analytics({
        eventCategory: `${this.gaContextPage} | Download Post`,
        eventAction: 'click',
        eventLabel: 'Clicked to open download modal'
      });
    }

    this.openModal('download', { postId: this.id, template: this.template });
  }

  openShareModal() {
    if (this.gaContextPage) {
      this.$analytics({
        eventCategory: `${this.gaContextPage} | Share Button`,
        eventAction: 'click',
        eventLabel: 'Clicked to open share modal'
      });
    }

    this.openModal('share', { postAssets: this.assets, postId: this.id });
  }

  openDeleteModal() {
    if (this.gaContextPage) {
      this.$analytics({
        eventCategory: `${this.gaContextPage} | Delete Button`,
        eventAction: 'click',
        eventLabel: 'Clicked to open delete dialog'
      });
    }

    this.openModal('delete', { postId: this.id });
  }

  toggleOptions() {
    this.options = !this.options;
  }

  closeOptions() {
    this.options = false;
  }

  get template() {
    if (this.postTemplate) {
      return TemplatesDictionary[this.postTemplate];
    }

    return ({
      placeholders: {},
      formats: []
    } as unknown) as IMarketingCenterTemplate;
  }
}
